// src/ui/feedbackRecusa.js
import { el } from '../lib/dom.js';
import { abrirModal } from './modal.js';
import { operadorAtual } from '../lib/operador.js';
import { feedbacksDecisao, marcarFeedbacksVistos } from '../domain/sugestoes.js';

/** Mostra (1x) ao operador o resultado das sugestoes dele: aprovadas e nao aprovadas. */
export async function mostrarFeedbacksRecusa(aoVisto) {
  let itens = [];
  try { itens = await feedbacksDecisao(operadorAtual.id); } catch (e) { return; }
  if (!itens.length) return;
  abrirModal({
    titulo: 'Sobre as suas sugestões',
    corpo: [
      el('p', { class: 'view__sub', style: 'margin-top:0', text: 'O gestor avaliou as suas sugestões. Obrigado por ajudar a melhorar o sistema!' }),
      el('ul', { class: 'feedback-recusa' }, itens.map((i) => {
        const ok = i.status === 'APROVADA';
        return el('li', {}, [
          el('span', {}, [
            el('i', { class: ok ? 'ph ph-check-circle' : 'ph ph-x-circle', style: 'margin-right:6px;color:' + (ok ? 'var(--verde)' : 'var(--vermelho, #e0483b)') }),
            el('span', { text: (i.kind === 'setor' ? 'Setor: ' : 'Chave: ') + i.texto + (ok ? ' — aprovada' : ' — não aprovada') }),
          ]),
          (!ok && i.motivo) ? el('div', { style: 'color:var(--muted);font-size:12px;margin-top:2px', text: 'Motivo do gestor: ' + i.motivo }) : null,
        ]);
      })),
    ],
    acoes: [
      { rotulo: 'Entendi', classe: 'btn btn--primario', onClick: async () => { await marcarFeedbacksVistos(itens); if (typeof aoVisto === 'function') { try { aoVisto(); } catch (e) { /* ignore */ } } return true; } },
    ],
  });
}